import { IconWrapper } from '../runtime';
export default IconWrapper('resume_format_s', false, function (h, props) {
  return h("svg", {
    "attrs": {
      "width": props.size,
      "height": props.size,
      "viewBox": "0 0 16 16",
      "fill": "none"
    }
  }, [h("path", {
    "attrs": {
      "d": "M0 2C0 0.895431 0.895431 0 2 0H14C15.1046 0 16 0.895431 16 2V14C16 15.1046 15.1046 16 14 16H2C0.895431 16 0 15.1046 0 14V2Z",
      "fill": "#1289DE"
    }
  }), h("path", {
    "attrs": {
      "d": "M2 16C0.895431 16 0 15.1046 0 14L16 14C16 15.1046 15.1046 16 14 16L2 16Z",
      "fill": "#0475C5"
    }
  }), h("path", {
    "attrs": {
      "d": "M8 16L8 14L16 14C16 15.1046 15.1046 16 14 16L8 16Z",
      "fill": "#239FF7"
    }
  }), h("path", {
    "attrs": {
      "d": "M4.99962 1.71655L4.97472 1.72877L4.99962 1.77953V1.71655Z",
      "fill": "white"
    }
  }), h("path", {
    "attrs": {
      "d": "M5.45272 2.70313L6.34318 4.51825L4.77637 8.10405L8.0111 12.0265L11.2306 8.1021L9.65771 4.52039L10.5649 2.70313H8.8884L8.00153 4.47962L9.48708 7.8624L8.00808 9.66523L6.51975 7.86045L7.99606 4.48176L7.1235 2.70313H5.45272Z",
      "fill": "white"
    }
  }), h("path", {
    "attrs": {
      "d": "M10.9996 1.75668V1.8324L11.0299 1.77179L10.9996 1.75668Z",
      "fill": "white"
    }
  })]);
});